// extracted by mini-css-extract-plugin
module.exports = {"container":"TemplateDownloadForm_container__uKxW9","checkboxField":"TemplateDownloadForm_checkboxField__R_ah_","submit":"TemplateDownloadForm_submit__06hDg"};